import React, { useState, useEffect, useContext } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';
import ClampUnit from '../../../../HyPET/assets/ClampUnit.svg';
import StationaryPlaten from '../../../../HyPET/assets/StationaryPlaten.svg';
import Mold from '../../../../HyPET/assets/Mold.svg';
import ClampLockCylinder from '../../../../HyPET/assets/ClampLockCylinder.svg';
import MovingPlaten from '../../../../HyPET/assets/MovingPlaten.svg';
import CylinderHousiing from '../../../../HyPET/assets/CylinderHousiing.svg';
import MoldStroke from '../../../../HyPET/assets/MoldStroke.svg';
import Ejector from '../../../../HyPET/assets/Ejector.svg';
import ClamPiston from '../../../../HyPET/assets/ClamPiston.svg';
import { KonvaEventObject } from 'konva/lib/Node';
import { MachineCanvasProps } from '../../../../InjectionCycle/components/interfaces';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../../../../App';

const ClampUnitCanvas: React.FC<MachineCanvasProps> = ({ hoveredPart, setHoveredPart, machineName, navigationState }) => {
    const navigate = useNavigate();
    const appContextProps: any = useContext(AppContext)
    const [stageSize, setStageSize] = useState({ width: window.innerWidth, height: 550 });

    const [ClampUnitImg] = useImage(ClampUnit);
    const [StationaryPlatenImg] = useImage(StationaryPlaten);
    const [MoldImg] = useImage(Mold);
    const [ClampLockCylinderImg] = useImage(ClampLockCylinder);
    const [MovingPlatenImg] = useImage(MovingPlaten);
    const [CylinderHousiingImg] = useImage(CylinderHousiing);
    const [MoldStrokeImg] = useImage(MoldStroke);
    const [EjectorImg] = useImage(Ejector);
    const [ClamPistonImg] = useImage(ClamPiston);

    const handleMouseMove = (e: KonvaEventObject<MouseEvent>) => {
        const { x, y } = e.target.getStage()?.getPointerPosition() || { x: 0, y: 0 };

        if (x >= stageSize.width * 0.707 && x <= stageSize.width * 0.74 && y >= stageSize.height * 0.13 && y <= stageSize.height * 0.4 && navigationState[("Stationary Platen").toLowerCase()]) {
            setHoveredPart('Stationary Platen');
        } else if (((x >= stageSize.width * 0.093 && x <= stageSize.width * 0.11 && y >= stageSize.height * 0.32 && y <= stageSize.height * 0.74) || (x >= stageSize.width * 0.112 && x <= stageSize.width * 0.12 && y >= stageSize.height * 0.32 && y <= stageSize.height * 0.74) || (x >= stageSize.width * 0.13 && x <= stageSize.width * 0.235 && ((y >= stageSize.height * 0.32 && y <= stageSize.height * 0.35) || (y >= stageSize.height * 0.55 && y <= stageSize.height * 0.58)))) && navigationState[("Cylinder Housing").toLowerCase()]) {
            setHoveredPart('Cylinder Housing');
        } else if (x >= stageSize.width * 0.184 && x <= stageSize.width * 0.45 && y >= stageSize.height * 0.398 && y <= stageSize.height * 0.47 && navigationState[("Ejector").toLowerCase()]) {
            setHoveredPart('Ejector');
        } else if (((x >= stageSize.width * 0.478 && x <= stageSize.width * 0.491 && y >= stageSize.height * 0.15 && y <= stageSize.height * 0.74) || (x >= stageSize.width * 0.491 && x <= stageSize.width * 0.51 && y >= stageSize.height * 0.35 && y <= stageSize.height * 0.54)) && navigationState[("Moving Platen").toLowerCase()] ) {
            setHoveredPart('Moving Platen');
        } else if (((x >= stageSize.width * 0.491 && x <= stageSize.width * 0.52) || (x >= stageSize.width * 0.641 && x <= stageSize.width * 0.68)) && y >= stageSize.height * 0.225 && y <= stageSize.height * 0.6 && navigationState[("Mold").toLowerCase()]) {
            setHoveredPart('Mold');
        } else if (x >= stageSize.width * 0.153 && x <= stageSize.width * 0.39 && ((y >= stageSize.height * 0.35 && y <= stageSize.height * 0.38) || (y >= stageSize.height * 0.50 && y <= stageSize.height * 0.53)) && navigationState[("Clamp Lock").toLowerCase()]) {
            setHoveredPart('Clamp Lock');
        } else if (x >= stageSize.width * 0.154 && x <= stageSize.width * 0.36 && y >= stageSize.height * 0.36 && y <= stageSize.height * 0.47 && navigationState[("Mold Stroke").toLowerCase()]) {
            setHoveredPart('Mold Stroke');
        } else if (((x >= stageSize.width * 0.258 && x <= stageSize.width * 0.3 && y >= stageSize.height * 0.31 && y <= stageSize.height * 0.47) || (x >= stageSize.width * 0.32 && x <= stageSize.width * 0.34 && y >= stageSize.height * 0.31 && y <= stageSize.height * 0.47) || (x >= stageSize.width * 0.31 && x <= stageSize.width * 0.32)) && navigationState[("Clamp Piston").toLowerCase()]) {
            setHoveredPart('Clamp Piston');
        } else {
            setHoveredPart('');
        }
    };

   useEffect(() => {
       const handleResize = () => {
         setStageSize({
           width: window.innerWidth - (appContextProps.sideBarOpenStatus ? 260 : 10),
           height: 550,
         });
       };
    handleResize(); // Call handleResize immediately to set the initial size
       window.addEventListener('resize', handleResize);
       return () => window.removeEventListener('resize', handleResize);
     }, [appContextProps.sideBarOpenStatus]);

    return (
        <Stage width={stageSize.width} height={stageSize.height} onMouseMove={handleMouseMove}>
            <Layer>
                <Image
                    image={ClampUnitImg}
                    x={stageSize.width * 0.08}
                    y={stageSize.height * 0.12}
                    width={stageSize.width * 0.70}
                    height={stageSize.height * 0.75}
                />
                {hoveredPart === 'Stationary Platen' && (
                    <Image
                        image={StationaryPlatenImg}
                        x={stageSize.width * 0.707}
                        y={stageSize.height * 0.13}
                        width={stageSize.width * 0.13}
                        height={stageSize.height * 0.16}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Stationary%20Platen/reportview`,{ state: navigationState[('Stationary Platen').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Mold' && (
                    <Image
                        image={MoldImg}
                        x={stageSize.width * 0.491}
                        y={stageSize.height * 0.225}
                        width={stageSize.width * 0.19}
                        height={stageSize.height * 0.37}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Mold/reportview`,{ state: navigationState[('Mold').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Clamp Lock' && (
                    <Image
                        image={ClampLockCylinderImg}
                        x={stageSize.width * 0.153}
                        y={stageSize.height * 0.28}
                        width={stageSize.width * 0.27}
                        height={stageSize.height * 0.265}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Clamp%20Lock/reportview`,{ state: navigationState[('Clamp Lock').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Moving Platen' && (
                    <Image
                        image={MovingPlatenImg}
                        x={stageSize.width * 0.397}
                        y={stageSize.height * 0.142}
                        width={stageSize.width * 0.167}
                        height={stageSize.height * 0.59}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Moving%20Platen/reportview`,{ state: navigationState[('Moving Platen').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Cylinder Housing' && (
                    <Image
                        image={CylinderHousiingImg}
                        x={stageSize.width * 0.093}
                        y={stageSize.height * 0.32}
                        width={stageSize.width * 0.142}
                        height={stageSize.height * 0.377}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Cylinder%20Housing/reportview`,{ state: navigationState[('Cylinder Housing').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Mold Stroke' && (
                    <Image
                        image={MoldStrokeImg}
                        x={stageSize.width * 0.154}
                        y={stageSize.height * 0.36}
                        width={stageSize.width * 0.205}
                        height={stageSize.height * 0.131}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Mold%20Stroke/reportview`,{ state: navigationState[('Mold Stroke').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Ejector' && (
                    <Image
                        image={EjectorImg}
                        x={stageSize.width * 0.384}
                        y={stageSize.height * 0.398}
                        width={stageSize.width * 0.157}
                        height={stageSize.height * 0.1}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Ejector/reportview`,{ state: navigationState[('Ejector').toLowerCase()] })}
                    />
                )}
                {hoveredPart === 'Clamp Piston' && (
                    <Image
                        image={ClamPistonImg}
                        x={stageSize.width * 0.258}
                        y={stageSize.height * 0.31}
                        width={stageSize.width * 0.08}
                        height={stageSize.height * 0.15}
                        onClick={() => navigate(`/usecase/injection-pdm/hycaps/${machineName}/Clamp%20Unit/Clamp%20Piston/reportview`,{ state: navigationState[('Clamp Piston').toLowerCase()] })}
                    />
                )}
            </Layer>
        </Stage>
    )
}

export default ClampUnitCanvas;
